import React from 'react';
import { Link, Redirect } from 'react-router-dom';
import Slider from "react-slick";
import { Modal } from 'react-bootstrap';

export class Guidelines extends React.Component {
  constructor(props) {
    super();
    this.state = {
      page_data: null,
      showVideo: null,
      current_step: 0,
      slide: 0
    };

    this.getItemStyle = this.getItemStyle.bind(this);
    this.setVideoShow = this.setVideoShow.bind(this);
    this.getQuoteStyle = this.getQuoteStyle.bind(this);
    this.getBannerStyle = this.getBannerStyle.bind(this);

    this.verticalSliderRef = React.createRef();
  }

  getPageContent() {
    var cur_location = window.location.pathname;
    cur_location = cur_location.substring(cur_location.lastIndexOf('/') + 1);
    cur_location = cur_location === "" ? 'Home' : cur_location
    fetch(process.env.REACT_APP_API_URL + '/Pages/GetPageContentByName/' + cur_location, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
        'access-control-allow-origin': '*',
        'Authorization': process.env.REACT_APP_AUTHORIZATION_KEY
      }
    })
      .then(res => res.json())
      .then((data) => {
        if (data.isSuccess) {
          this.setState({ page_data: data });
        }
      })
      .catch((error) => {
        console.error('Error:', error);
      })
  }

  getItemStyle = (webImage, mobileImage) => ({
    backgroundImage: window.matchMedia('screen and (max-width: 1199.98px)').matches ? 'url(' + mobileImage + ')' : 'url(' + webImage + ')'
  });

  getQuoteStyle = (image, color) => ({
    backgroundImage: 'url(' + image + ')',
    backgroundColor: color
  });

  getCarouelLayout = (size) => ({
    width: 'calc(100% / ' + size + ') !important'
  });

  getBannerStyle = (webImage, mobileImage) => ({
    backgroundImage: window.matchMedia('screen and (max-width: 575.98px)').matches ? 'url(' + mobileImage + ')' : 'url(' + webImage + ')'
  });

  setVideoShow = (index) => {
    this.setState({ showVideo: index });
  }

  goToStep = (index, id) => {
    this.setState({ current_step: index });
    this[`${id}`].slickGoTo(index);
  }

  selectPage = (val) => {
    this.setState({ slide: val });
    this.verticalSliderRef.current.slickGoTo(val);
  };

  nextSlide = (val) => {
    //var cur_slide = this.state.slide;
    this.verticalSliderRef.current.slickGoTo(val + 1);
  };

  prevSlide = (val) => {
    //var cur_slide = this.state.slide;
    this.verticalSliderRef.current.slickGoTo(val - 1);
  };

  componentDidMount() {
    this.getPageContent();

  }

  render() {
    var pagedata = this.state.page_data;
    var cur_step = this.state.current_step;
    return (
      <section id={pagedata ? pagedata.name : ""}>
        {pagedata && pagedata.modules.map((data, index) => {
          if (data.type === 'Banner') {
            return (
              <div key={index} id={data.scrollId ? data.scrollId : data.id}>
                {data.data.map((child, child_index) => {
                  return (
                    <div key={child_index} className={'container-fluid content-wrapper position-relative ' + data.type} style={this.getBannerStyle(child.imageWeb, child.imageMobile)}>
                      <div className="container">
                        <div className="row ">
                          <div className="col-md-12 banner-box w-100">
                            <div className="box text-center">
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="position-absolute bg-flush w-100 h-100 top-0 left-0 pt-5 d-flex align-items-center justify-content-start">
                        <div className="container">
                          <div className="row ">
                            <div className="col-md-12">
                              <p className="text-light d-flex align-items-center">Home <span className="material-icons">chevron_right</span></p>
                              <h1 className="theme-font-color font-weight-bold m-0">{child.title}</h1>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="position-absolute" style={{ right: 15, bottom: 10 }}>
                        {child.caption && <small className="text-light"><i>*{child.caption}</i></small>}
                      </div>
                    </div>
                  )
                })
                }
              </div>
            )
          }
          if (data.type === 'HomeInformational') {
            return (
              <div key={index} id={data.scrollId ? data.scrollId : data.id}>
                {data.data.map((child, child_index) => {
                  return (
                    <div key={child_index} className={'container-fluid content-wrapper position-relative section-1 p-0 ' + data.type} style={this.getItemStyle(child.imageWeb, child.imageMobile)}>
                      <div className="bg-shaded">
                        <div className="container">
                          <div className="row">
                            <div className="col-md-12 d-flex align-items-center banner-box">
                              <div className="box text-center text-md-left">
                                <h1 className="theme-font-color font-weight-bold underline">{child.title}</h1>
                                <p className="text-light mt-3 paragraph-spacing paragraphWithoutSpace paragraphWithWhite" dangerouslySetInnerHTML={{ __html: child.description }}></p>
                                <a href={child.link} target="_self" className="btn btn-theme rounded-pill px-4">Find out more</a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="position-absolute fixed-bottom text-center">
                        <section id="section09" className="animation-1 d-none d-md-block">
                          <a href="#section10"><span></span></a>
                        </section>
                        <div className="d-block d-md-none">
                          <img src="images/double_down.png" className="pb-3 icon-xl" alt="" />
                        </div>
                        {/* <img src="images/Homepage/scroll down.svg" className="img-scroll" alt="backtotop" /> */}
                      </div>
                      {child.caption && <div className="position-absolute fixed-bottom text-right pb-2 pr-2 text-light">
                        <small>*{child.caption}</small>
                      </div>}
                    </div>
                  )
                })
                }
              </div>
            )
          }
          if (data.type === 'Card') {
            return (
              <div key={index} id={data.scrollId ? data.scrollId : data.id}>
                <div className={'container-fluid section-spacing-topdown ' + data.type + 'Module'}>
                  <div className="container">
                    <div className="row">
                      <div className="col-md-12">
                        <h2 className="underline font-weight-bold">{data.title}</h2>
                      </div>
                    </div>
                    <div className="row row-cols-md-2 g-4 mt-2">
                      {data.data.map((child, child_index) => {
                        return (
                          <div key={child_index} className="col pr-2">
                            <div className="card py-md-5 py-3 position-relative">
                              <div className="card-body d-flex justify-content-center align-items-center">
                                <a href={child.link} target="_self" className="w-100 h-100 d-flex justify-content-center align-items-center">
                                  <div className="text-center">
                                    <img src={child.imageWeb} className="mb-3 img-card" alt="" />
                                    <p className="card-text">{child.title}</p>
                                  </div>
                                </a>
                              </div>
                              <div className="position-absolute w-100 h-100">
                                <a href={child.link} target="_self" className="text-light font-weight-bold w-100 h-100 d-flex justify-content-center align-items-center text-center noselect"><span>Click here to view more</span></a>
                              </div>
                            </div>
                          </div>
                        )
                      })
                      }
                    </div>
                  </div>
                </div>
              </div>
            )
          }
          if (data.type === 'Informational-image') {
            return (
              <div key={index} id={data.scrollId ? data.scrollId : data.id}>
                {data.data.map((child, child_index) => {
                  return (
                    <div key={child_index} className={'container-fluid position-relative section-spacing-topdown ' + data.type}>
                      <div className="container">
                        {(data.position === 1 || data.position === 2) && <div className="row">
                          <div className={data.position === 1 ? 'col-md-6 order-1' : 'col-md-6 order-2 mt-md-0 mt-3'}>
                            {child.title && <h2 className="underline font-weight-bold">{child.title}</h2>}
                            {child.description && <p className="paragraphWithoutSpace" dangerouslySetInnerHTML={{ __html: child.description }}></p>}
                            {child.link && <a href={child.link} target="_self" className="btn btn-theme rounded-pill px-4">Learn more</a>}
                          </div>
                          <div className={data.position === 1 ? 'col-md-6 order-2 mt-md-0 mt-3' : 'col-md-6 order-1'}>
                            <figure className="m-0">
                              <img src={child.imageWeb} className="img-rps" alt="" />
                              <figcaption>
                                {child.caption && <small className="text-dark"><i>*{child.caption}</i></small>}
                              </figcaption>
                            </figure>
                          </div>
                        </div>}
                        {(data.position === 3 || data.position === 4) && <div className="row">
                          <div className={data.position === 3 ? 'col-md-12 order-2 mt-md-0 mt-3' : 'col-md-12 order-1'}>
                            {child.title && <h2 className="underline font-weight-bold">{child.title}</h2>}
                            {child.description && <p className="paragraphWithoutSpace" dangerouslySetInnerHTML={{ __html: child.description }}></p>}
                            {child.link && <a href={child.link} rel="noreferrer" target="_self" className="btn btn-theme rounded-pill px-4">Learn more</a>}
                          </div>
                          <div className={data.position === 3 ? 'col-md-12 order-1' : 'col-md-12 order-2 mt-md-0 mt-3'}>
                            <figure className="m-0">
                              <img src={child.imageWeb} className="img-rps" alt="" />
                              <figcaption>
                                {child.caption && <small className="text-dark"><i>*{child.caption}</i></small>}
                              </figcaption>
                            </figure>
                          </div>
                        </div>}
                      </div>
                    </div>
                  )
                })
                }
              </div>
            )
          }
          if (data.type === 'Informational-video') {
            return (
              <div key={index} id={data.scrollId ? data.scrollId : data.id}>
                {data.data.map((child, child_index) => {
                  return (
                    <div key={child_index} className={'container-fluid position-relative section-spacing-topdown ' + data.type}>
                      <div className="container">
                        {(data.position === 1 || data.position === 2) && <div className="row">
                          <div className={data.position === 1 ? 'col-md-6 order-1' : 'col-md-6 order-2 mt-md-0 mt-3'}>
                            {child.title && <h2 className="underline font-weight-bold">{child.title}</h2>}
                            {child.description && <p className="paragraphWithoutSpace" dangerouslySetInnerHTML={{ __html: child.description }}></p>}
                          </div>
                          <div className={data.position === 1 ? 'col-md-6 order-2 mt-md-0 mt-3' : 'col-md-6 order-1'}>
                            <div className="position-relative video d-flex justify-content-center cursor_pointer" onClick={() => this.setVideoShow(index + child_index)}>
                              <div className="video-image">
                                <figure className="m-0">
                                  <img src={child.imageWeb} className="img-rps" alt="" />
                                  <figcaption>
                                    {child.caption && <small className="text-dark"><i>*{child.caption}</i></small>}
                                  </figcaption>
                                </figure>
                              </div>
                              <div className="position-absolute video-button d-flex justify-content-center align-items-center w-100 h-100">
                                <img src="images/Experiences/Icon feather-play-circle.svg" alt="" />
                              </div>
                              {/* <div className="position-absolute video-overlay d-flex justify-content-end">
                                <img src="images/NationalOutdoor/Mask Group 49.png" alt="" />
                              </div> */}
                            </div>
                          </div>
                          <Modal show={this.state.showVideo === index + child_index} onHide={() => this.setVideoShow(null)} size="lg" centered className="p-0">
                            <Modal.Body>
                              <iframe className="w-100 h-100" src={child.link} title={child.title} frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
                            </Modal.Body>
                            <Modal.Footer className="py-1 px-3">
                              <button className="btn btn-secondary" onClick={() => this.setVideoShow(null)}>Close</button>
                            </Modal.Footer>
                          </Modal>
                        </div>}
                        {(data.position === 3 || data.position === 4) && <div className="row">
                          <div className={data.position === 3 ? 'col-md-12 order-2 mt-md-0 mb-3' : 'col-md-12 order-1 mb-3'}>
                            {child.title && <h2 className="underline font-weight-bold">{child.title}</h2>}
                            {child.description && <p className="paragraphWithoutSpace" dangerouslySetInnerHTML={{ __html: child.description }}></p>}
                          </div>
                          <div className={data.position === 3 ? 'col-md-12 order-1 d-flex justify-content-center mb-3' : 'col-md-12 order-2 d-flex justify-content-center mt-md-0 mb-3'}>
                            <div className="position-relative video d-flex justify-content-center cursor_pointer" onClick={() => this.setVideoShow(index + child_index)}>
                              <div className="video-image">
                                <figure className="m-0">
                                  <img src={child.imageWeb} className="img-rps" alt="" />
                                  <figcaption>
                                    {child.caption && <small className="text-dark"><i>*{child.caption}</i></small>}
                                  </figcaption>
                                </figure>
                              </div>
                              <div className="position-absolute video-button d-flex justify-content-center align-items-center w-100 h-100">
                                <img src="images/Experiences/Icon feather-play-circle.svg" alt="" />
                              </div>
                              {/* <div className="position-absolute video-overlay d-flex justify-content-end">
                                <img src="images/NationalOutdoor/Mask Group 49.png" alt="" />
                              </div> */}
                            </div>
                          </div>
                          <Modal show={this.state.showVideo === index + child_index} onHide={this.setVideoShow} size="lg" centered className="p-0">
                            <Modal.Body>
                              <iframe className="w-100 h-100" src={child.link} title={child.title} frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
                            </Modal.Body>
                            <Modal.Footer className="py-1 px-3">
                              <button className="btn btn-secondary" onClick={this.setVideoShow}>Close</button>
                            </Modal.Footer>
                          </Modal>
                        </div>}
                      </div>
                    </div>
                  )
                })
                }
              </div>
            )
          }
          if (data.type === 'CTABanner') {
            return (
              <div key={index} id={data.scrollId ? data.scrollId : data.id}>
                {data.data.map((child, child_index) => {
                  return (
                    <div key={child_index} className={'container-fluid position-relative ' + data.type} style={this.getQuoteStyle(child.imageWeb, child.backgroundColor)}>
                      <div className="container">
                        <div className="row">
                          <div className="col-md-12 d-flex justify-content-center align-items-center content-box">
                            <div className="text-center theme-sub-color">
                              {child.title && <h2 className="font-weight-bold">{child.title}</h2>}
                              <div className="d-flex flex-row title-special-underline justify-content-center my-3">
                                <div></div>
                                <div></div>
                                <div></div>
                              </div>
                              {child.description && <p className="theme-sub-color p-18 paragraphWithoutSpace" dangerouslySetInnerHTML={{ __html: child.description }}></p>}
                              {child.link && <a href={child.link} target="_self" className="btn btn-theme rounded-pill px-4">Find out more</a>}
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* <div className="position-absolute fixed-bottom img-pattern">
                      <img src="images/homepage/sectionpattern.svg" alt="" className="img-fluid" />
                    </div> */}
                    </div>
                  )
                })
                }
              </div>
            )
          }
          if (data.type === 'Quote') {
            return (
              <div key={index} id={data.scrollId ? data.scrollId : data.id}>
                {data.data.map((child, child_index) => {
                  return (
                    <div key={child_index} className={'container-fluid position-relative ' + data.type} style={this.getQuoteStyle(child.imageWeb, child.backgroundColor)}>
                      <div className="container">
                        <div className="row">
                          <div className="col-md-12 d-flex justify-content-center align-items-center content-box">
                            <div className="text-center text-light box">
                              <div className="pb-3">
                                <div className="mb-2 d-flex justify-content-start"><img src="images/Activities/Group 4027.svg" alt="" /></div>
                                <h4 className="font-weight-bold m-0 paragraphWithoutSpace paragraphWithWhite" dangerouslySetInnerHTML={{ __html: child.description }}></h4>
                                <div className="mt-2 d-flex justify-content-end"><img src="images/Activities/Group 4028.svg" alt="" /></div>
                              </div>
                              <div className="underline-xs">
                                <small>-<i>{child.caption}</i></small>
                              </div>

                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )
                })
                }
              </div>
            )
          }
          if (data.type === 'Stepper') {
            return (
              <div key={index} id={data.scrollId ? data.scrollId : data.id} className={'container-fluid position-relative section-spacing-top sectionSlider-spacing-bottom ' + data.type}>
                <div className="container">
                  <div className="row">
                    <div className="col-12">
                      <h2 className="underline font-weight-bold">{data.title}</h2>
                      <p className="paragraphWithoutSpace" dangerouslySetInnerHTML={{ __html: data.description }}></p>
                    </div>
                  </div>
                  <div className="row mt-3">
                    <div className="col-md-12">
                      <div className="stepper">
                        <ul className="list-unstyled d-flex align-items-center">
                          {data.data.map((child, child_index) => {
                            return (
                              <li key={child_index} className={cur_step === child_index ? 'rounded-circle d-flex justify-content-center align-items-center active' : 'rounded-circle d-flex justify-content-center align-items-center'} onClick={() => this.goToStep(child_index, data.id)}>{child_index + 1}</li>
                            )
                          })
                          }
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="container">
                  <Slider {...{
                    dots: false,
                    infinite: false,
                    speed: 500,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    adaptiveHeight: true,
                    arrows: false,
                    beforeChange: (current, next) =>
                      this.goToStep(next, data.id),
                    responsive: [
                      {
                        breakpoint: 1024,
                        settings: {
                          slidesToShow: 1,
                          slidesToScroll: 1,
                        }
                      },
                      {
                        breakpoint: 600,
                        settings: {
                          slidesToShow: 1,
                          slidesToScroll: 1
                        }
                      },
                      {
                        breakpoint: 480,
                        settings: {
                          slidesToShow: 1,
                          slidesToScroll: 1
                        }
                      }
                    ]
                  }} className="slider" ref={el => this[`${data.id}`] = el}>
                    {data.data.map((child, child_index) => {
                      return (
                        <div key={child_index}>
                          {child.posts && child.posts.length <= 0 && <div className="row mt-3">
                            <div className="col-md-6">
                              {child.imageWeb && <div className="border-theme">
                                <img src={child.imageWeb} className="img-rps" alt={child.title} />
                              </div>}
                            </div>
                            <div className="col-md-6 mt-3 mt-md-0">
                              <h4 className="theme-sub-color">Step {child_index + 1}</h4>
                              <p className="paragraphWithoutSpace" dangerouslySetInnerHTML={{ __html: child.description }}></p>
                              {child.link && <a href={child.link} target="_self" className="btn btn-outline-primary mt-2 rounded-pill px-4"><span className="material-icons materialSize align-middle">picture_as_pdf</span>&nbsp;<span className="align-top">{child.caption}</span></a>}
                            </div>
                          </div>}
                          {child.posts && child.posts.length > 0 && <div className="row mt-3">
                            <div className="col-md-12">
                              <div className="px-lg-0 px-3">
                                {child.posts && child.posts.length > 0 && <h4 className="color-76">{child.title}</h4>}
                                <p className="paragraphWithoutSpace" dangerouslySetInnerHTML={{ __html: child.description }}></p>
                                {child.link && <a href={child.link} target="_self" className="btn btn-outline-primary mt-2 rounded-pill px-4"><span className="material-icons materialSize align-middle">picture_as_pdf</span>&nbsp;<span className="align-top">{child.caption}</span></a>}
                              </div>
                            </div>
                            <div className="col-md-12">
                              {child.posts && child.posts.map((posts, posts_index) => {
                                return (
                                  <div key={posts_index} className="multipleCards mt-4">
                                    {posts.postData && posts.postData.map((post, post_index) => {
                                      return (
                                        <div className="card" key={post_index}>
                                          <div className="pt-4 text-center img-reg">
                                            {post.imageWeb && <img src={post.imageWeb} className="mx-auto img-rps" alt={post.title} />}
                                          </div>
                                          <div className="card-body d-flex justify-content-between flex-wrap">
                                            <div>
                                              {post.title && <h5 className="card-title theme-sub-color">{post.title}</h5>}
                                              {post.description && <p className="paragraphWithoutSpace w-100" dangerouslySetInnerHTML={{ __html: post.description }}></p>}

                                            </div>
                                            <div className="d-flex align-items-end">
                                              {post.link && <a href={post.link} target="_self">{post.button}<span className="material-icons pl-1 pt-1 align-top">launch</span></a>}
                                            </div>
                                          </div>
                                        </div>

                                      )
                                    })
                                    }
                                  </div>
                                )
                              })
                              }
                            </div>
                          </div>}
                        </div>
                      )
                    })
                    }
                  </Slider>
                </div>
              </div>
            )
          }
          if (data.type === 'Carousel1') {
            return (
              <div key={index} id={data.scrollId ? data.scrollId : data.id} className={'container-fluid position-relative section-spacing-top sectionSlider-spacing-bottom ' + data.type}>
                <div className="container">
                  <div className="row">
                    <div className="col-md-12">
                      <h2 className="underline font-weight-bold">{data.title}</h2>
                      <p className="paragraphWithoutSpace" dangerouslySetInnerHTML={{ __html: data.description }}></p>
                    </div>
                  </div>
                </div>
                <div className="container">
                  <div className="row">
                    <div className="col-md-12 p-0 overflow-hidden">
                      <Slider {...{
                        dots: true,
                        infinite: false,
                        speed: 500,
                        slidesToShow: data.cardCount ? data.cardCount : 3,
                        slidesToScroll: 1,
                        adaptiveHeight: false,
                        responsive: [
                          {
                            breakpoint: 1024,
                            settings: {
                              slidesToShow: 2,
                              slidesToScroll: 1,
                            }
                          },
                          {
                            breakpoint: 600,
                            settings: {
                              slidesToShow: 1,
                              slidesToScroll: 1
                            }
                          },
                          {
                            breakpoint: 480,
                            settings: {
                              slidesToShow: 1,
                              slidesToScroll: 1
                            }
                          }
                        ]
                      }} className="slider">
                        {data.data.map((child, child_index) => {
                          return (
                            <div key={child_index} className="slide">
                              <div className="card position-relative h-100 p-4">
                                <img src={child.imageWeb} className="img-rps mx-auto" alt={child.title} />
                                <div className="card-body p-0 pt-3">
                                  <h5 className="card-title theme-sub-color">{child.title}</h5>
                                  <p className="card-text paragraphWithoutSpace" dangerouslySetInnerHTML={{ __html: child.description }}></p>
                                </div>
                              </div>
                            </div>
                          )
                        })
                        }
                      </Slider>
                    </div>
                  </div>
                </div>
              </div>
            )
          }
          if (data.type === 'Carousel2') {
            return (
              <div key={index} id={data.scrollId ? data.scrollId : data.id} className={'container-fluid position-relative section-spacing-bottom ' + data.type} >
                <div className="container">
                  <div className="row">
                    <div className="col-12">
                      <h2 className="underline font-weight-bold">{data.title}</h2>
                      <p className="paragraphWithoutSpace" dangerouslySetInnerHTML={{ __html: data.description }}></p>
                    </div>
                  </div>
                </div>
                <div className="container">
                  <Slider {...{
                    dots: true,
                    infinite: true,
                    rows: 2,
                    slidesPerRow: data.cardCount ? data.cardCount : 4,
                    adaptiveHeight: false,
                    responsive: [
                      {
                        breakpoint: 769,
                        settings: {
                          rows: 1,
                          slidesPerRow: 2,
                        }
                      },
                      {
                        breakpoint: 480,
                        settings: {
                          rows: 1,
                          slidesPerRow: 1,
                        }
                      }
                    ]
                  }}>
                    {data.data.map((child, child_index) => {
                      return (
                        <div key={child_index} className="slide" style={this.getCarouelLayout(data.cardCount ? data.cardCount : 4)}>
                          <div className="card">
                            <div className="pt-4 text-center">
                              <img src={child.imageWeb} className="img-rps mx-auto" alt={child.title} />
                            </div>
                            <div className="card-body">
                              <p className="paragraphWithoutSpace" dangerouslySetInnerHTML={{ __html: child.description }}></p>
                            </div>
                          </div>
                        </div>
                      )
                    })
                    }
                  </Slider>
                </div>
              </div>
            )
          }
          if (data.type === 'Carousel3') {
            return (
              <div key={index} id={data.scrollId ? data.scrollId : data.id} className={'container-fluid section-spacing-topdown bg-white ' + data.type}>
                <div className="container">
                  <div className="row">
                    <div className="col-md-6 col-12">
                      <h2 className="underline font-weight-bold">{data.title}</h2>
                      <p className="paragraphWithoutSpace" dangerouslySetInnerHTML={{ __html: data.description }}></p>
                    </div>
                  </div>
                </div>
                <div className="container">
                  <div className="row">
                    <div className="col-md-12 pr-md-5">
                      <div className="position-relative">
                        <Slider {... {
                          dots: false,
                          infinite: true,
                          slidesToShow: 1,
                          slidesToScroll: 1,
                          vertical: true,
                          verticalSwiping: true,
                          swipeToSlide: true,
                          adaptiveHeight: false,
                          // dotsClass: "vertical-dots",
                          arrows: false,
                          afterChange: (index) =>
                            this.selectPage(index),
                          responsive: [
                            {
                              breakpoint: 769,
                              settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1,
                                dots: true,
                                infinite: true,
                                vertical: false,
                                verticalSwiping: false,
                                swipeToSlide: true,
                                adaptiveHeight: false,
                                dotsClass: "slick-dots",
                              }
                            },
                            {
                              breakpoint: 480,
                              settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1,
                                dots: true,
                                infinite: true,
                                vertical: false,
                                verticalSwiping: false,
                                swipeToSlide: true,
                                adaptiveHeight: false,
                                dotsClass: "slick-dots",
                              }
                            }
                          ]
                        }} ref={this.verticalSliderRef}>
                          {data.data.map((child, child_index) => {
                            return (
                              <div key={child_index} className="d-lg-flex align-items-start justify-content-between flex-wrap flex-lg-nowrap">
                                <div className="flex-shrink-0 pr-md-3">
                                  <div className="position-relative section-img">
                                    <img src={child.imageWeb} className="img-rps rounded" alt={child.title} />
                                    <div className="position-absolute" style={{ right: 5, bottom: 5, zIndex: 10 }}>
                                      <small className="text-light"><i>*{child.caption}</i></small>
                                    </div>
                                  </div>
                                </div>
                                <div className="flex-grow-1 section-text mt-3 mt-lg-0 d-flex align-items-center">
                                  <div>
                                    <h4 className="theme-sub-color">{child.title}</h4>
                                    <p className="paragraphWithoutSpace my-3" dangerouslySetInnerHTML={{ __html: child.description }}></p>
                                  </div>
                                </div>
                              </div>
                            )
                          })
                          }
                        </Slider>
                        <div className={'arrows position-absolute d-lg-flex d-none justify-content-center'}>
                          <div className="text-center">
                            <div className="dots">

                              <ul className="vertical-dots mb-1">
                                {data.data.map((child, child_index) => {
                                  return (
                                    <li key={child_index} className={this.state.slide === child_index ? 'slick-active' : ''}><button onClick={() => this.selectPage(child_index)}></button></li>
                                  )
                                })
                                }
                              </ul>
                            </div>
                            {/* <img className="cursor_pointer" src="images/Experiences/arrows.svg" alt="arrow" onClick={() => prevSlide(slide_num - 1)} /> */}
                            {/* <img className="cursor_pointer" src="images/Experiences/arrows.svg" alt="arrow" onClick={() => nextSlide(slide_num + 1)} /> */}
                            <div className="arrow-up cursor_pointer" onClick={() => this.prevSlide(this.state.slide)}><span className="material-icons">expand_less</span></div>
                            <div className="arrow-down cursor_pointer" onClick={() => this.nextSlide(this.state.slide)}><span className="material-icons">expand_more</span></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )
          }
          if (data.type === 'Testimonials') {
            return (
              <div key={index} id={data.scrollId ? data.scrollId : data.id} className={'container-fluid section-spacing-top mb-5 ' + data.type}>
                <div className="container">
                  <div className="row">
                    <div className="col-md-12">
                      <h2 className="underline font-weight-bold">{data.title}</h2>
                      <p className="paragraphWithoutSpace" dangerouslySetInnerHTML={{ __html: data.description }}></p>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12 p-0 overflow-hidden">
                      <Slider {...{
                        dots: true,
                        infinite: false,
                        speed: 500,
                        slidesToShow: data.cardCount ? data.cardCount : 3,
                        slidesToScroll: 2,
                        adaptiveHeight: false,
                        responsive: [
                          {
                            breakpoint: 1024,
                            settings: {
                              slidesToShow: 2,
                              slidesToScroll: 1,
                            }
                          },
                          {
                            breakpoint: 600,
                            settings: {
                              slidesToShow: 1,
                              slidesToScroll: 1
                            }
                          },
                          {
                            breakpoint: 480,
                            settings: {
                              slidesToShow: 1,
                              slidesToScroll: 1
                            }
                          }
                        ]
                      }} className="slider">
                        {data.data.map((child, child_index) => {
                          return (
                            <div key={child_index} className="slide">
                              <div className="card position-relative h-100">
                                <div className="card-body d-flex align-content-between flex-wrap">
                                  <div className="card-desc w-100">
                                    <div className="text-start">
                                      <img src="images/homepage/doubleQuote.png" className="mb-3" alt="" />
                                    </div>
                                    <p className="paragraphWithoutSpace card-text" dangerouslySetInnerHTML={{ __html: child.description }}></p>
                                    <div className="d-flex justify-content-end">
                                      <img src="images/homepage/doubleQuoteLeft.png" className="mb-3" alt="" />
                                    </div>
                                  </div>
                                  <div className="d-flex align-items-center flex-row justify-content-start pt-2">
                                    <div>
                                      <p className="m-0 p-14">{child.caption}</p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )

                        })
                        }
                      </Slider>
                    </div>
                  </div>
                </div>
              </div>
            )
          }
          if (data.type === 'Map') {
            return (
              <div key={index} id={data.scrollId ? data.scrollId : data.id} className={'container-fluid section-spacing-topdown ' + data.type}>
                <div className="container">
                  <div className="row">
                    <div className="col-md-12">
                      <h2 className="underline font-weight-bold">{data.title}</h2>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12">
                      <p className="paragraphWithoutSpace mb-3" dangerouslySetInnerHTML={{ __html: data.description }}></p>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12 mt-3 overflow-auto d-flex justify-content-md-center">
                      <div className="position-relative map">
                        <div className="map-image">
                          <img src="images/Experiences/Singapore Map.png" alt="" />
                        </div>
                        {data.map && data.map.coordinates.map((child, child_index) => {
                          return (
                            <div key={child_index} className={'position-absolute map-item map-item-'+(child_index+1)} style={{top: parseInt(child.yCoord) - 188, left: parseInt(child.xCoord) - 216}}>
                            <div className="h-100 position-relative box-popover">
                              <div className="d-flex justify-content-center align-items-center h-100">
                                <span></span>
                              </div>
                              <div className="position-absolute box">
                                <p className="box-title mb-2 font-weight-bold" style={{ fontSize: '105%' }}>{child.title}</p>
                                <p className="box-content m-0 paragraphWithoutSpace" dangerouslySetInnerHTML={{ __html: child.description }}></p>
                              </div>
                            </div>
                          </div>
                          )
                        })
                        }
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )
          }
          if (data.type === 'Note') {
            return (
              <div key={index} id={data.scrollId ? data.scrollId : data.id}>
                {data.data.map((child, child_index) => {
                  return (
                    <div key={child_index} className={'container-fluid bg-light section-spacing-topdown ' + data.type}>
                      <div className="container">
                        <div className="row">
                          <div className="col-md-12">
                            <div className="card border-danger bg-alert mb-3">
                              <div className="card-body text-danger p-4">
                                <p className="card-title font-weight-bold d-flex align-items-center m-0 text-danger mb-2"><img className="pr-1" src="images/Registration/Icon awesome-exclamation-triangle.svg" alt="alert" />{child.title}</p>
                                <p className="card-text text-danger paragraphWithoutSpace card-text" dangerouslySetInnerHTML={{ __html: child.description }}></p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )
                })
                }
              </div>
            )
          }
          if (data.type === 'FreeText') {
            return (
              <div key={index} id={data.scrollId ? data.scrollId : data.id}>
                {data.data.map((child, child_index) => {
                  return (
                    <div key={child_index} className={'container-fluid bg-light section-spacing-top ' + data.type}>
                      <div className="container">
                        <div className="row">
                          <div className="col-md-12">
                            <p className="card-textparagraphWithoutSpace card-text" dangerouslySetInnerHTML={{ __html: child.description }}></p>
                          </div>
                        </div>
                      </div>
                    </div>
                  )
                })
                }
              </div>
            )
          }
        })
        }
      </section >
    );
  }
}

